class PvrGalleryRerender extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();

    document.forms[this.getAttribute('observe-form')]?.addEventListener(
      'product:rerender',
      (event) => this.onProductRerender(event),
      { capture: true, signal: this.abortController.signal }
    );
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  onProductRerender(event) {
    this.reapplyDisabledBuyButtons(event);

    const matchingGallery = event.detail.htmlFragment.querySelector(`#${this.id}`);

    if (
      matchingGallery &&
      matchingGallery.dataset.galleryProductId !== this.dataset.galleryProductId
    ) {
      this.replaceWith(matchingGallery);
    }
  }

  reapplyDisabledBuyButtons(event) {
    const currentProductRerender = this.closest('product-rerender');

    if (!currentProductRerender?.id) {
      return;
    }

    const matchingProductRerender = event.detail.htmlFragment.querySelector(
      `#${currentProductRerender.id}`
    );
    const matchingBuyButtons = matchingProductRerender?.querySelector(
      '[data-block-type="buy-buttons"] buy-buttons'
    );

    if (!matchingBuyButtons?.querySelector('button[type="submit"]')?.disabled) {
      return;
    }

    const disabledBuyButtons = matchingBuyButtons.cloneNode(true);
    const observedFormId = this.getAttribute('observe-form');
    const matchingVariantIdInput = event.detail.htmlFragment
      .getElementById(observedFormId)
      ?.querySelector('input[name="id"]');
    const matchingVariantId = matchingVariantIdInput?.value;

    queueMicrotask(() => {
      const currentBuyButtons = currentProductRerender.querySelector(
        '[data-block-type="buy-buttons"] buy-buttons'
      );

      if (
        currentBuyButtons &&
        !currentBuyButtons.querySelector('button[type="submit"]')?.disabled
      ) {
        currentBuyButtons.replaceWith(disabledBuyButtons);

        const variantIdInput = document.forms[observedFormId]?.querySelector('input[name="id"]');

        if (variantIdInput && matchingVariantId !== undefined) {
          variantIdInput.value = matchingVariantId;
        }
      }
    });
  }
}

if (!customElements.get('pvr-gallery-rerender')) {
  customElements.define('pvr-gallery-rerender', PvrGalleryRerender);
}
